import { CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { BadgeV3 } from '@cimplico/components';
import { useIsActiveSubscription } from '../../hooks/use-is-active-subscription';
import { SparklesIcon } from '@heroicons/react/20/solid';

type IntegrationCardProps = {
    id: string;
    title: string;
    description: string;
    logo: string;
    status?: 'ISSUE' | 'CONNECTED' | 'DEFAULT';
    beta?: boolean;
    onConfigure?: (id: string) => void;
    isDisabled?: boolean;
    _new?: boolean;
};

function IntegrationCard({
    id,
    title,
    description,
    logo,
    status = 'DEFAULT',
    beta,
    onConfigure,
    isDisabled = false,
    _new = false,
}: IntegrationCardProps): JSX.Element {
    const activeSubscription = useIsActiveSubscription();

    const styles = {
        borderColour: {
            DEFAULT: 'border-gray-200 dark:border-white/[0.07]',
            ISSUE: 'border-yellow-300 dark:border-yellow-400',
            CONNECTED: 'border-green-300 dark:border-green-400',
        },
        bgColour: {
            DEFAULT: 'bg-white dark:bg-white/[0.05]',
            ISSUE: 'bg-yellow-50 dark:bg-yellow-400/[0.10]',
            CONNECTED: 'bg-green-50 dark:bg-green-400/[0.10]',
        },
    };

    return (
        <div className={`rounded-lg border ${styles.borderColour[status]} ${styles.bgColour[status]} shadow-sm px-4 pt-4 grid gap-y-2`}>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <img src={logo} className="w-8 h-8" />
                    <h3 className=" text-gray-800 dark:text-gray-200 text-base font-bold">{title}</h3>
                </div>

                <div className="ml-auto flex gap-2">
                    {beta && <BadgeV3 size="small" rounded={false} color="indigo" label="Beta" />}
                    {_new && <BadgeV3 size="small" rounded={false} color="indigo" label="New" leftIcon={<SparklesIcon />} />}
                    {status === 'CONNECTED' && <CheckCircleIcon className="w-5 h-5 text-green-500 dark:text-green-400" />}
                    {status === 'ISSUE' && <ExclamationTriangleIcon className="w-5 h-5 text-yellow-500 dark:text-yellow-400" />}
                </div>
            </div>
            <div className="h-9">
                <p className="text-left text-xs text-gray-600 dark:text-gray-400 w-[222px] line-clamp-2">{description}</p>
            </div>
            <button
                className={`border-t ${styles.borderColour[status]} py-2 ${
                    activeSubscription && !isDisabled ? 'text-indigo-600 dark:text-indigo-400' : 'text-gray-600 dark:text-gray-400'
                } text-xs font-medium text-left`}
                onClick={(): void => onConfigure && onConfigure(id)}
                disabled={!activeSubscription || isDisabled}
            >
                Configure
            </button>
        </div>
    );
}
export default IntegrationCard;
